export default "__VITE_ASSET__CLhv3EJP__"